import { DEFAULT_PAGE_HEIGHT } from '../types';
import type { PresentationSlide, SlideBackground, SlideElement, SlideVisual } from '../types';

export function newElementId(): string {
  return `e${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
}

export function newTextElement(pageHeight = DEFAULT_PAGE_HEIGHT): SlideElement {
  return {
    id: newElementId(), type: 'text', x: 150, y: pageHeight / 2 - 40, width: 700, height: 80, rotation: 0, opacity: 1,
    text: {
      paragraphs: [{ runs: [{ text: 'Nieuwe tekst', color: '#000000', font_size: 40 }], align: 'left' }], anchor: 'top', padding: 7,
    },
  };
}

export function newShapeElement(kind: 'rect' | 'ellipse', pageHeight = DEFAULT_PAGE_HEIGHT): SlideElement {
  return {
    id: newElementId(), type: 'shape', shape: kind, x: 350, y: pageHeight / 2 - 100, width: 300, height: 200, rotation: 0,
    opacity: 1, fill: '#2e7d32', stroke: null, stroke_width: 0,
  };
}

export function newImageElement(mediaId: string, pageHeight = DEFAULT_PAGE_HEIGHT): SlideElement {
  return {
    id: newElementId(), type: 'image', media_id: mediaId, fit: 'contain', x: 250, y: pageHeight / 2 - 150, width: 500, height: 300,
    rotation: 0, opacity: 1,
  };
}

/** Wat bij een slide wordt opgeslagen. */
export function visualOf(slide: PresentationSlide | SlideVisual): { elements: SlideElement[]; background: SlideBackground | null } {
  return { elements: slide.elements || [], background: slide.background || null };
}
